export default "__VITE_ASSET__Czu7uL2g__"